import React from 'react';

const NotFound = () => {
  return (
    <div>
      <div className='grid px-4 bg-white h-96 place-content-center'>
        <h1 className='tracking-widest text-gray-500 uppercase'>
          404 | Not Found
        </h1>
      </div>
    </div>
  );
};

export default NotFound;
